<footer class="footer">
    <div class="footer-content">
        <div class="footer-brand">
            <span class="logo">AXIS Academy</span>
            <div>
                <small>{{ 'FOOTER.BRAND.DESCRIPTION_1' | translate }}
                    <br> {{ 'FOOTER.BRAND.DESCRIPTION_2' | translate }}</small>
            </div>
        </div>

        <nav class="footer-links">
            <div style="display: flex; flex-direction: column;">
                <a (click)="goToHome()">{{ 'FOOTER.LINKS.HOME' | translate }}</a>
                <a href="https://coinfo.online" target="_blank">{{ 'FOOTER.LINKS.ABOUT_US' | translate }}</a>
                <a (click)="goToPolicies()">{{ 'FOOTER.LINKS.POLICIES' | translate }}</a>
            </div>
        </nav>

        <div class="footer-social" style="gap: 15px;">
            <div style="display:flex; flex-direction:column; align-items:center;">
                <img src="assets/images/logos/logo_coinfo.png" alt="Coinfo"
                     style="height: 50px; width: 155px;" loading="lazy">
<!--                <small style="margin-top:2px; line-height:1;">-->
                    <a href="https://www.coinfo.online" target="_blank" rel="noopener"
                       style="color:white; text-decoration:underline; font-size:14px; margin:2px; line-height:1; align-self:flex-end;">
                        www.coinfo.online
                    </a>
            </div>
        </div>
    </div>

    <div class="footer-bottom">
        <small>&copy; 2026 AXIS Academy | {{ 'FOOTER.COPYRIGHT' | translate }}</small>
        <small> <a href="https://www.coinfo.online" target="_blank" rel="noopener" class="footer-link">
            | {{ 'FOOTER.DEVELOPER' | translate }}
        </a></small>
    </div>
</footer>
